<template>
  <UIDrawer
    :title
    :is-open
    :z-index
    :allow-tray
    @minimize="handleMinimize"
    @close="handleClose"
  >
    <AccountForm :instance="modal.entity" @close="handleClose" />
  </UIDrawer>
</template>

<script setup lang="ts">
import { computed } from 'vue'

import { AssetClass } from '..'
import { ModalClass } from '@types'

import {
  INCOME_ACCOUNT_MODAL_TITLE,
  INCOME_ACCOUNT_MODAL_TITLE_NEW,
  EXPENSE_ACCOUNT_MODAL_TITLE,
  EXPENSE_ACCOUNT_MODAL_TITLE_NEW,
} from './utils/const'

import { UIDrawer } from '@ui/modals'
import AccountForm from './AccountForm.vue'

type Props = {
  modal: ModalClass<AssetClass>
}

const props = defineProps<Props>()

const newTitle = computed(() =>
  props.modal.entity.isIncomeAccount
    ? INCOME_ACCOUNT_MODAL_TITLE_NEW
    : EXPENSE_ACCOUNT_MODAL_TITLE_NEW,
)
const commonTitle = computed(() =>
  props.modal.entity.isIncomeAccount
    ? INCOME_ACCOUNT_MODAL_TITLE
    : EXPENSE_ACCOUNT_MODAL_TITLE,
)
const title = computed(() =>
  props.modal.entity.isNew ? newTitle.value : commonTitle.value,
)

const isOpen = computed(() => props.modal.isOpened)

const zIndex = computed(() => props.modal.zIndex)
const allowTray = computed(() => props.modal.allowTray)

const handleMinimize = () => {
  props.modal.hide()
}

const handleClose = () => {
  props.modal.conditionalClose()
}
</script>
